import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { useJsonLd, usePageMeta } from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/faqs";

export default function FaqPage() {
  usePageMeta({
    title: "常见问题 - 选美吃瓜内定与评分猫腻如何判断 | 吃瓜深扒社",
    description:
      "选美吃瓜内定是不是定论？评分猫腻通常出现在哪几个环节？赞助品牌进入评委席为什么值得关注？这里回答了读者最常追问的六个问题。",
    keywords: "选美吃瓜常见问题,选美吃瓜内定,评分猫腻,选美吃瓜评委,爆料可信度",
    path: "/faq",
  });

  useJsonLd("faq", {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "FAQPage",
        "@id": "https://dstcm.cn/faq#faqpage",
        url: "https://dstcm.cn/faq",
        inLanguage: "zh-CN",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer,
          },
        })),
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://dstcm.cn/" },
          { "@type": "ListItem", position: 2, name: "常见问题", item: "https://dstcm.cn/faq" },
        ],
      },
    ],
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Breadcrumbs
          items={[
            { label: "首页", to: "/" },
            { label: "常见问题" },
          ]}
        />

        <section className="border-b border-background-200 bg-secondary-100">
          <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
            <span className="flex items-center gap-2 font-label text-xs tracking-[0.2em] text-primary-600">
              <i className="ri-question-answer-line" aria-hidden="true"></i>
              FAQ
            </span>
            <h1 className="mt-3 max-w-3xl font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
              常见问题：关于内定、评分猫腻与爆料可信度
            </h1>
            <p className="mt-4 max-w-3xl text-sm leading-loose text-foreground-800">
              这些问题来自读者的反复追问。我们把它们整理出来，是因为判断一场比赛是否干净，靠的不是情绪，而是对规则与流程的理解。
            </p>
          </div>
        </section>

        <section className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
            <div className="lg:col-span-8">
              <FaqAccordion items={faqs} defaultOpenId="f1" />
            </div>

            <aside className="lg:col-span-4">
              <div className="lg:sticky lg:top-24 space-y-5">
                <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                  <h2 className="font-heading text-lg font-bold text-foreground-950">想自己动手核对？</h2>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                    评分口径三步核对法写在专题页里，不需要内部资料就能判断一场比赛的计分流程是否存在可被操作的空间。
                  </p>
                  <Link
                    to="/topics"
                    className="mt-5 flex items-center justify-center gap-2 rounded-md border border-foreground-900 px-4 py-2.5 font-label text-sm text-foreground-900 transition-colors hover:bg-foreground-900 hover:text-background-50 whitespace-nowrap"
                  >
                    去看专题内容
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </Link>
                </div>

                <div className="rounded-lg bg-primary-50 p-6">
                  <h2 className="font-heading text-lg font-bold text-primary-950">还有别的疑问？</h2>
                  <p className="mt-3 text-sm leading-relaxed text-primary-900">
                    没找到答案的话，可以直接订阅并把问题写给我们，也可以在投递线索时一并说明。
                  </p>
                  <Link
                    to="/about#contact"
                    className="mt-5 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
                  >
                    <i className="ri-mail-send-line" aria-hidden="true"></i>
                    去联系我们
                  </Link>
                </div>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}